import EigenLeadsDiagramFrame from './EigenLeadsDiagramFrame';
import { eigenLeadsPalette, elType } from './eigenLeadsPalette';
import { ElDefs, ElGrid, ElSectionLabel, ElPanel, ElBus, ElConnector } from './eigenLeadsDiagramKit';

const PREFIX = 'elHero';

const sources = [
  { id: 'a', x: 100, label: 'SOURCE A', sub: 'Verified ingest' },
  { id: 'b', x: 360, label: 'eigenLeads', sub: 'Governed program', active: true },
  { id: 'c', x: 620, label: 'SOURCE B', sub: 'Diversified lane' },
];

const pillars = [
  { label: 'TRUST', colorKey: 'indigo' },
  { label: 'RELIABLE', colorKey: 'emerald' },
  { label: 'CONSISTENT', colorKey: 'amber' },
  { label: 'AVAILABLE', colorKey: 'rose' },
];

/** Governed lead supply platform — multi-source in, ranked queue out. */
const EigenLeadsHeroDiagram = ({ theme = 'dark' }) => {
  const isDark = theme === 'dark';
  const c = eigenLeadsPalette(isDark);
  const pillarColor = { indigo: c.indigo, emerald: c.emerald, amber: c.amber, rose: c.rose };

  return (
    <EigenLeadsDiagramFrame
      theme={theme}
      caption="Governed lead supply · diversified sources · ranked delivery"
      className="el-hero-frame"
    >
      <svg
        viewBox="0 0 720 440"
        className="w-full h-auto el-hero-svg"
        role="img"
        aria-label="eigenLeads governed lead supply platform architecture"
      >
        <ElDefs prefix={PREFIX} isDark={isDark} />
        <rect width="720" height="440" fill={c.bg} />
        <ElGrid width={720} height={440} c={c} />

        <ElSectionLabel x={360} y={36} c={c}>
          GOVERNED LEAD SUPPLY PLATFORM
        </ElSectionLabel>

        {sources.map(({ id, x, label, sub, active }, i) => (
          <ElPanel
            key={id}
            x={x - 88}
            y={72}
            w={176}
            h={120}
            prefix={PREFIX}
            c={c}
            active={active}
            className={`el-hero-source el-hero-source-${i}`}
          >
            <text x={x} y={100} textAnchor="middle" fill={active ? c.indigo : c.label} {...elType.title}>
              {label}
            </text>
            <text x={x} y={118} textAnchor="middle" fill={c.muted} {...elType.sub}>
              {sub}
            </text>
            <text x={x} y={168} textAnchor="middle" fill={c.mono} {...elType.monoSm}>
              {active ? 'program.core' : 'ingest.lane'}
            </text>
          </ElPanel>
        ))}

        <ElConnector x1={188} y1={132} x2={272} y2={132} c={c} prefix={PREFIX} />
        <ElConnector x1={448} y1={132} x2={532} y2={132} c={c} prefix={PREFIX} />

        <ElBus x1={72} y1={228} x2={648} y2={228} prefix={PREFIX} className="el-hero-bus" />
        <circle r="5" fill={c.indigo} filter={`url(#${PREFIX}-glow)`} className="el-hero-bus-dot">
          <animateMotion dur="7s" repeatCount="indefinite" path="M 72 228 L 648 228" />
        </circle>
        <text x={360} y={212} textAnchor="middle" fill={c.indigo} {...elType.section}>
          SUPPLY BUS
        </text>
        <text x={360} y={248} textAnchor="middle" fill={c.mono} {...elType.mono}>
          territory_id · provenance · compliance_checked
        </text>

        {pillars.map(({ label, colorKey }, i) => {
          const x = 108 + i * 152;
          const color = pillarColor[colorKey];
          return (
            <g key={label} className={`el-hero-pillar el-hero-pillar-${i}`}>
              <rect x={x - 56} y={272} width="112" height="36" rx="6" fill="none" stroke={color} strokeWidth="1" className="el-hero-pillar-box" />
              <text x={x} y={294} textAnchor="middle" fill={color} {...elType.title}>
                {label}
              </text>
            </g>
          );
        })}

        <ElPanel x={48} y={328} w={300} h={88} prefix={PREFIX} c={c} stroke={c.amber}>
          <text x={72} y={352} fill={c.amber} {...elType.section}>
            QUALITY GATE
          </text>
          <text x={72} y={370} fill={c.label} {...elType.title}>
            EigenScore™ · QualityCert™
          </text>
          <text x={72} y={388} fill={c.mono} {...elType.monoSm}>
            score ≥ 0.72 · reachability verified
          </text>
        </ElPanel>

        <ElPanel x={372} y={328} w={300} h={88} prefix={PREFIX} c={c} active stroke={c.emerald}>
          <text x={396} y={352} fill={c.emerald} {...elType.section}>
            RANKED QUEUE
          </text>
          <text x={396} y={370} fill={c.label} {...elType.mono}>
            #1 · intent:high · score:0.94
          </text>
          <text x={396} y={386} fill={c.mono} {...elType.monoSm}>
            #2 · score:0.89 · #3 · score:0.86
          </text>
          <circle cx={640} cy={372} r="5" fill={c.emerald} filter={`url(#${PREFIX}-glow)`} className="el-hero-queue-pulse" />
        </ElPanel>
      </svg>
    </EigenLeadsDiagramFrame>
  );
};

export default EigenLeadsHeroDiagram;
